/**
 * Individual board square component
 */

import React from 'react';
import type { Square, Piece, Color } from '@jester-chess/shared';
import { PieceIcon } from './PieceIcon';
import './BoardSquare.css';

interface BoardSquareProps {
  square: Square;
  piece: Piece | undefined;
  isLight: boolean;
  selected: boolean;
  validMove: boolean;
  onClick: (square: Square) => void;
  yourColor: Color;
}

export const BoardSquare: React.FC<BoardSquareProps> = ({
  square,
  piece,
  isLight,
  selected,
  validMove,
  onClick,
}) => {
  const handleClick = () => {
    onClick(square);
  };

  return (
    <div
      className={`board-square ${isLight ? 'light' : 'dark'} ${selected ? 'selected' : ''} ${validMove ? 'valid-move' : ''}`}
      onClick={handleClick}
    >
      {piece && <PieceIcon piece={piece} />}
      {validMove && !piece && <div className="move-indicator" />}
    </div>
  );
};

